import { render, staticRenderFns } from "./PaywallFormPackageTags.vue?vue&type=template&id=06a213a8&scoped=true"
import script from "./PaywallFormPackageTags.vue?vue&type=script&lang=js"
export * from "./PaywallFormPackageTags.vue?vue&type=script&lang=js"
import style0 from "./PaywallFormPackageTags.vue?vue&type=style&index=0&id=06a213a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a213a8",
  null
  
)

export default component.exports